import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Download, Plus } from "lucide-react";
import api from "@/lib/api";
import { inr, fmtDate, downloadCSV } from "@/lib/format";
import { PageHeader, Empty } from "@/components/Bits";
import StatusChip from "@/components/StatusChip";

const STATUSES = ["All", "Paid", "Partial", "Issued", "Returned", "Void"];
const CHANNELS = ["All", "Walk-in", "WhatsApp", "Instagram", "Website"];

export default function Invoices() {
  const nav = useNavigate();
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("All");
  const [channel, setChannel] = useState("All");
  const [q, setQ] = useState("");

  const load = async () => {
    const qs = [];
    if (status !== "All") qs.push(`status=${status}`);
    if (channel !== "All") qs.push(`channel=${channel}`);
    if (q) qs.push(`q=${encodeURIComponent(q)}`);
    setList((await api.get(`/invoices${qs.length ? "?" + qs.join("&") : ""}`)).data);
  };
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [status, channel, q]);

  const exportCSV = () => downloadCSV("invoices.csv", ["invoice_number", "date", "customer_name", "channel", "total", "amount_paid", "balance", "status"], list);

  return (
    <div>
      <PageHeader eyebrow="Register" title="Invoices" subtitle="Every sale across the counter and online channels.">
        <button className="btn btn-gold" onClick={exportCSV} disabled={!list.length} data-testid="invoices-export"><Download size={16} /> Export CSV</button>
        <button className="btn btn-primary" onClick={() => nav("/sales/new")} data-testid="invoices-new"><Plus size={16} /> New invoice</button>
      </PageHeader>

      <div className="flex items-center gap-3 mb-5 flex-wrap">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8C929B]" />
          <input className="field pl-9" placeholder="Search invoice # or customer…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="invoice-search" />
        </div>
        <select className="field w-auto" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="filter-status">
          {STATUSES.map((s) => <option key={s}>{s}</option>)}
        </select>
        <select className="field w-auto" value={channel} onChange={(e) => setChannel(e.target.value)} data-testid="filter-channel">
          {CHANNELS.map((c) => <option key={c}>{c}</option>)}
        </select>
      </div>

      <div className="card overflow-hidden">
        <table className="tbl">
          <thead><tr><th>Invoice</th><th>Date</th><th>Customer</th><th>Channel</th><th className="num">Total</th><th className="num">Paid</th><th className="num">Balance</th><th>Status</th></tr></thead>
          <tbody>
            {list.map((i) => (
              <tr key={i.id} className="cursor-pointer" onClick={() => nav(`/invoices/${i.id}`)} data-testid={`invoice-row-${i.invoice_number}`}>
                <td className="font-num">{i.invoice_number}</td>
                <td className="text-[#5C626A]">{fmtDate(i.date)}</td>
                <td>{i.customer_name}</td>
                <td className="text-[#5C626A]">{i.channel}</td>
                <td className="num font-num">{inr(i.total)}</td>
                <td className="num font-num text-[#2D5A3C]">{inr(i.amount_paid)}</td>
                <td className="num font-num" style={{ color: i.balance > 0 ? "#A3411D" : "#8C929B" }}>{inr(i.balance)}</td>
                <td><StatusChip status={i.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <Empty>No invoices match your filters</Empty>}
      </div>
    </div>
  );
}
